import { useEffect } from "react";
import api from "@/lib/api";

// Met à jour le badge (pastille) sur l'icône de l'app installée (PWA)
// en fonction du nombre total de non-lus (messages + notifications).
export default function AppBadge() {
  useEffect(() => {
    const supported = "setAppBadge" in navigator;
    let stopped = false;

    const apply = (n) => {
      if (!supported) return;
      try {
        if (n > 0) navigator.setAppBadge(n);
        else navigator.clearAppBadge();
      } catch { /* ignore */ }
    };

    const refresh = () => {
      api.get("/badge-count")
        .then((r) => { if (!stopped) apply(r.data?.total || 0); })
        .catch(() => {});
    };

    refresh();
    const interval = setInterval(refresh, 20000);
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", refresh);

    return () => {
      stopped = true;
      clearInterval(interval);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", refresh);
    };
  }, []);

  return null;
}
